import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appDynamicScreenHeight]'
})
export class DynamicScreenHeightDirective implements AfterViewInit {

  constructor(
    private el: ElementRef,
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => this.setElementHeight());
  }

  setElementHeight(): void {
    const rect = this.el.nativeElement.getBoundingClientRect();
    const height = window.innerHeight - rect.top;
    this.el.nativeElement.style.height = `${height}px`;
  }

}
